var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14286 9.42857H14.2857C14.9166 9.42857 15.4286 8.91657 15.4286 8.28571C15.4286 7.65486 14.9166 7.14286 14.2857 7.14286H1.14286C0.512 7.14286 0 7.65486 0 8.28571C0 8.91657 0.512 9.42857 1.14286 9.42857ZM22.8571 0H1.14286C0.512 0 0 0.512 0 1.14286C0 1.77371 0.512 2.28571 1.14286 2.28571H22.8571C23.488 2.28571 24 1.77371 24 1.14286C24 0.512 23.488 0 22.8571 0ZM17.1429 14.2857H1.14286C0.512 14.2857 0 14.7977 0 15.4286C0 16.0594 0.512 16.5714 1.14286 16.5714H17.1429C17.7737 16.5714 18.2857 16.0594 18.2857 15.4286C18.2857 14.7977 17.7737 14.2857 17.1429 14.2857Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align_left.1809c20e199f46fb35756e3a7b044c63.svg";
export { ForwardRef as ReactComponent };